import React, {useEffect} from 'react';

import AppButton from '../../../components/Button/AppButton';
import ConnectionTrackButton from '../../../components/Button/ConnectionTrackButton/ConnectionTrackButton';
import ArticlePageLayout from '../../../components/DataDisplay/ArticlePageLayout';
import {WarningIcon} from '../../../components/Icons';
import PopupFullPage from '../../../components/Popup/PopupFullPage';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import analyticsService from '../../../services/analyticsService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {hideModalAction} from '../../../state/ducks/modal';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import helpers from '../../../utils/helpers';

const PairingSkipPopup = (props) => {
    const {onTryAgain, onSkip, modalType, dispatch, deviceType} = props;
    const localizedStrings = getLocalizedStrings();

    const hidePopup = () => dispatch(hideModalAction(modalType));
    const onCancelBtnClick = () => {
        //hide popup directly, fix documentTitle bug
        hidePopup();
        helpers.runFunction(onTryAgain);
    };
    const onConfirmBtnClick = () => {
        hidePopup();
        helpers.runFunction(onSkip);
    };

    useEffect(() => analyticsService.pushPairingQuitSetupEvent(deviceType), []);

    useDocumentTitle(localizedStrings[localizationKeys.QUIT_DEVICE_SET_UP_TITLE], true);

    return (
        <PopupFullPage
            contentLabel={localizedStrings[localizationKeys.QUIT_SET_UP_TITLE_TEXT]}
            data-testid={elementsTesIds.PAIRING_SEQUENCE_SKIP_PAGE}
        >
            <ArticlePageLayout
                containerClassName='pb-0 pt-[72px] lg:pt-[60px]'
                className='lg:max-w-[724px]'
                icon={<WarningIcon className='mb-5 h-9 w-9' />}
                titleText={localizedStrings[localizationKeys.QUIT_SET_UP_TITLE_TEXT]}
                titleClassName='mb-4'
                descriptionText={localizedStrings[localizationKeys.QUIT_SET_UP_DESCRIPTION_TEXT]}
                descriptionClassName='mb-[60px] lg:max-w-[472px]'
            >
                <div className='flex w-full flex-col items-center'>
                    <ConnectionTrackButton
                        ariaLabel={
                            localizedStrings[localizationKeys.QUIT_DEVICE_SET_UP_BTN_DEVICE_LIST_PAGE_ARIA_LABEL]
                        }
                        button={AppButton}
                        secondary
                        light
                        className='mb-4 mt-0'
                        onClick={onConfirmBtnClick}
                        testId={elementsTesIds.PAIRING_SKIP_POPUP_CONFIRM_BUTTON}
                    >
                        {localizedStrings[localizationKeys.QUIT_SET_UP_CONFIRM_BUTTON_TEXT]}
                    </ConnectionTrackButton>
                    <ConnectionTrackButton
                        button={AppButton}
                        secondary
                        light
                        className='mt-0'
                        onClick={onCancelBtnClick}
                        testId={elementsTesIds.PAIRING_SKIP_POPUP_CANCEL_BUTTON}
                    >
                        {localizedStrings[localizationKeys.QUIT_SET_UP_CANCEL_BUTTON_TEXT]}
                    </ConnectionTrackButton>
                </div>
            </ArticlePageLayout>
        </PopupFullPage>
    );
};

export default PairingSkipPopup;
